/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
'use strict';
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$('body').removeClass('no-js').addClass('js-enabled');

$('.content-viewport table').wrap('<div class="table-responsive"></div>');

(function (window) {
  window.setSq = function (key, value) {
    if (typeof window.sq == 'undefined') {
      window.sq = {};
    }
    window.sq[key] = value;
  };
})(window);
/*
--------------------
Modules
--------------------
*/

/*
 * Table of Contents
 *
 *  CAROUSEL
 *  LINKS
 *  GEOLOCATION
 *  flyToElement
 *  ADD TO CART
 *
 */

/*
--------------------
1. CAROUSEL
--------------------
*/
(function ($, window) {
  function makeCarousels() {
    var $carousel = $('.slick-slideshow');

    $carousel.slick({
      dots: true,
      arrows: false,
      autoplay: true,
      speed: 600,
      autoplaySpeed: 5000,
      appendDots: $('.slick-slideshow__paging'),
      slide: '.slick-slideshow__slide',
      slidesToScroll: 1,
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      useTransform: false,
    });

    if ($carousel.hasClass('slick-dotted')) {
      var $playButton = $('<li></li>')
        .addClass('slick-action play')
        .attr('attr-hidden', 'false')
        .attr('role', 'presentation')
        .hide();

      var $playActionButton = $('<button></button>')
        .attr('type', 'button')
        .addClass('action play')
        .attr('role', 'button')
        .attr('aria-required', 'false')
        .attr('tabindex', '0')
        .attr('title', 'Play');

      if ($carousel.find('.slick-slideshow__slide').length > 1) {
        $playActionButton.appendTo($playButton);
      }
      $('.slick-actions').html('');
      $('.slick-actions').prepend($playButton);

      var $pauseButton = $('<li></li>')
        .addClass('slick-action pause')
        .attr('attr-hidden', 'false')
        .attr('role', 'presentation');

      $('<button></button>')
        .attr('type', 'button')
        .addClass('action pause')
        .appendTo($pauseButton)
        .attr('role', 'button')
        .attr('aria-required', 'false')
        .attr('tabindex', '0')
        .attr('title', 'Pause');

      $('.slick-actions').prepend($pauseButton);

      $('.pause').bind('click', function () {
        $carousel.slick('slickPause').slick('slickSetOption', 'pauseOnDotsHover', false);

        $pauseButton.hide();
        $playButton.show();
      });

      $('.play').bind('click', function () {
        $carousel.slick('slickPlay').slick('slickSetOption', 'pauseOnDotsHover', true);

        $playButton.hide();
        $pauseButton.show();
      });

      $('.slick-slideshow__paging').width($('.slick-dots').width() + 25);
      $('.slick-slideshow__paging').css('left', 'calc(50%  - (' + $('.slick-dots').width() / 2 + 'px + 10px ) )');
    }
  }
  // window.sq.makeCarousels = makeCarousels;
  window.setSq('makeCarousels', makeCarousels);
  makeCarousels();
})(jQuery, window);

/*
--------------------
2. LINKS
--------------------
*/

(function ($) {
  $('a:not(.video, .popup)')
    .filter(function () {
      return this.hostname && this.hostname !== location.hostname;
    })
    .addClass('external')
    .attr('target', '_blank')
    .attr('title', 'opens in a new window');

  $('a.external:has(img)').removeClass('external');

  $('.question').each(function () {
    var $this = $(this),
      $thisText = $this.text().replace(/^\s+|\s+$/g, ''),
      $charLimit = 70,
      $ellipsis = $thisText.length > $charLimit ? '...' : '',
      $tooltipText = $thisText.slice(0, $charLimit) + $ellipsis;

    // Replace all instances of span to allow for tabbing (focus)
    // Add data attribute for tooltip
    // Init trigger for tooltip
    $this.replaceWith(function () {
      return $('<a class="question">' + '</a>')
        .attr('data-tipso', $tooltipText)
        .tipso({
          background: '#002147',
          position: 'right',
          tooltipHover: 'false',
        });
    });
  });
})(jQuery);

/*
--------------------
3. GEO
--------------------
*
* Elements with data-country='xxx' will be selected and displayed
* if sharing location is disabled, function displays all every element that has data-country attribute.
*
*/

var country;
if (typeof localStorage.country !== 'undefined') {
  country = localStorage.country;
} else {
  country = 'INT';
}

(function ($) {
  var countryCode = function () {
    var r = $.Deferred();

    $(
      '<p class="subLabel loading"><span class="icon icon-gear icon-spin right"></span><span class="label grey">Detecting your location...</span></p>'
    ).insertBefore($('*[data-country]:first-child'));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          var data;

          $.ajax({
            dataType: 'json',
            url:
              'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
              latitude +
              ',' +
              longitude +
              '&key=AIzaSyDP1JP7Sj2gtFtuX4ZmhS5_NG78yVi-zFg',
            data: data,
            success: function (data) {
              if (data.status === 'OK') {
                if (data.results.length > 0) {
                  function getLongAddressObject(object) {
                    let address = {};
                    const addressComponents = object.results[0].address_components;
                    addressComponents.forEach(element => {
                      address[element.types[0]] = element.long_name;
                    });
                    return address;
                  }

                  country = getLongAddressObject(data).country;
                  localStorage.country = country;
                  r.resolve();
                }
              } else {
                country = 'INT';
              }
            },
          });
        },
        function (error) {
          //console.log(error);
          r.resolve();
        }
      );
    } else {
      r.resolve();
      country = 'INT';
      localStorage.country = country;
    }

    return r;
  };

  var showCountryInfo = function () {
    if (country === 'INT') {
      $('*[data-country]').show();
    } else {
      $('*[data-country=' + country + ']').show();
    }
    $('.loading').fadeOut();
  };

  // only fires the function if there are any tag with 'data-country' attribute in the page
  if ($('*[data-country]').length) {
    var totalWeight = 0;

    const shoppingCartItems = $('.shoppingcart--item');
    const deliveryInterfaceItems = $('.gtm-product-data');

    if (shoppingCartItems.length > 0) {
      shoppingCartItems.each(function () {
        totalWeight += $(this).data('weight');
      });
    } else if (deliveryInterfaceItems.length > 0) {
      deliveryInterfaceItems.each(function () {
        totalWeight += $(this).data('weight');
      });
    }

    // not digital
    if (totalWeight > 0) {
      if (typeof localStorage.country !== 'undefined') {
        showCountryInfo();
      } else {
        countryCode().done(showCountryInfo);
      }
    }
  }
})(jQuery);

/*
--------------------
4. We have created a JavaScript function called flyToElement().
You need to pass the flyer element into the first parameter and flying to element into the second parameter.
--------------------
*/

/**
 * Animates a flying element from its current position to a target element's position.
 *
 * @param {jQuery} flyer - The jQuery element that will be animated.
 * @param {jQuery} flyingTo - The jQuery element representing the target position.
 */
function flyToElement(flyer, flyingTo) {
  flyer = flyer[0];
  flyingTo = flyingTo[0];

  const flyerClone = flyer.cloneNode(true),
    flyerOffset = flyer.getBoundingClientRect(),
    flyingToOffset = flyingTo.getBoundingClientRect();

  flyerClone.classList.add('product-image__wrapper--shadow');

  flyerClone.style.width = flyerOffset.width + 'px';
  flyerClone.style.height = flyerOffset.height + 'px';

  const applyStyles = styles =>
    Object.entries(styles).forEach(([prop, value]) => flyerClone.style.setProperty(`--flyup-${prop}`, value));

  const flyerStartStyles = {
    scale: 1,
    opacity: 1,
    left: flyerOffset.left + window.scrollX + 'px',
    top: flyerOffset.top + window.scrollY + 'px',
  };

  // apply initial styles
  applyStyles(flyerStartStyles);

  // append child
  document.body.appendChild(flyerClone);

  // handle event
  const onTransitionEnd = () => {
    flyerClone.removeEventListener('transitionend', onTransitionEnd);
    flyerClone.remove();
  };

  // setup events
  flyerClone.addEventListener('transitionend', onTransitionEnd, true);

  let img = flyerClone;

  if (flyerClone.tagName !== 'IMG') {
    img = flyerClone.querySelector('img');
  }

  // initisalise transition on img load
  img.onload = () => {
    const flyerEndStyles = {
      scale: 0,
      opacity: 0,
      left: flyingToOffset.left + window.scrollX + 'px',
      top: flyingToOffset.top + window.scrollY + 'px',
    };

    applyStyles(flyerEndStyles);
  };
}

/*
--------------------
5. ADD TO CART
--------------------
*/
(function ($, window) {
  var $cartNumber = function () {
    return $('.header-cart .label');
  };

  var $cartIcon = function () {
    return $('.header-cart .icon');
  };

  var number = parseInt($('#cartNumber').text(), 10) || 0;

  $cartNumber().text(number);
  $('.bubble').text(number);

  if (number === 0) {
    $('.header-cart').attr('title', 'There are currently no items in your cart');
  } else {
    $('.header-cart').attr('title', 'View my cart');
  }

  function addToCart(e) {
    var url = e.attr('href');

    // gtm tracking
    //var targetElm = e[0];
    var $gtmDataElement = e.parents('.gtm-product-data')[0];
    //console.log('$gtmDataElement :', $gtmDataElement);

    if ($gtmDataElement && typeof window.gtmTracking !== 'undefined') {
      var data = gtmTracking.getGtmElementData($gtmDataElement);
      //console.log('data:',data);

      if (data.id) {
        //assumes that if there is an id, then we should have other data too.
        window.dataLayer.push({ ecommerce: null });

        window.dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            currencyCode: 'AUD',
            add: {
              // 'add' actionFieldObject measures.
              products: [data],
            },
          },
        });

        // GA4 event
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'AUD',
            items: [data],
          },
        });
      } else {
        console.warn('GTM Tracking Data Not Available:', data);
      }
    } else {
      console.warn('GTM Tracking Data Element Missing OR window.gtmTracking is undefined.');
    }

    // needs work
    $.get(url, function () {});

    var cartNumber = parseInt($cartNumber().text(), 10);
    $('.header-cart').attr('title', 'View my cart');

    $cartNumber().text(cartNumber + 1);
    $('.bubble').text(cartNumber + 1);

    //$(window).scrollTop(0);
    var $body = $('html, body');
    // $body.animate({scrollTop: 0}, '500', 'swing');
    //Select item image and pass to the function
    //console.log($(e).parent().parent());
    var detailsImage = $(e).parent().parent().find('.product--tile__image, .product-image__wrapper');
    var productImage = detailsImage.length ? detailsImage : $(e).closest('.js-product').find('.js-product-image');

    if ($(document).width() >= 1024) {
      flyToElement(productImage, $('.header-cart'));
    } else {
      flyToElement(productImage, $('.mobile-header-cart'));
    }

    $cartIcon().addClass('adding');
    setTimeout(function () {
      $cartIcon().removeClass('adding');
    }, 1000);
  }

  function bindAddToCart(selector) {
    $(selector).click(function (e) {
      e.preventDefault();
      if (!$(this).hasClass('product--cart__disabled')) {
        addToCart($(this));
      }
    });
  }

  bindAddToCart('.add-to-cart');
  // window.sq.bindAddToCart = bindAddToCart;
  window.setSq('bindAddToCart', bindAddToCart);
})(jQuery, window);

(function ($) {
  var body = $('html, body');
  $('.backToTop').click(function (e) {
    e.preventDefault();
    body.animate({ scrollTop: 0 }, '800', 'swing');
  });
})(jQuery);

// set up block links on series details page
(function ($) {
  $('.block .document').each(function prepareLinks() {
    var $this = $(this);
    if (!$this.find('.attribute-title').text()) {
      $this.find('.asset-file-size').hide();
      $this.find('.attribute-title').hide();
    } else {
      $this.find('.asset-name').hide();
    }
  });
})(jQuery);

function leadTracking($) {
  /*
   * https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
   */
  function getUrlParams() {
    var search = location.search.substring(1);

    if (search == '') {
      return {};
    }

    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === '' ? value : decodeURIComponent(value);
    });
  }

  var attributes = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'id_mc', 'sfmc_id', 'sfmc_activityid'];

  var urlParams = getUrlParams();

  var paramsToAppend = [];
  for (var attributeKey in attributes) {
    if (urlParams.hasOwnProperty(attributes[attributeKey])) {
      paramsToAppend.push(attributes[attributeKey] + '=' + encodeURIComponent(urlParams[attributes[attributeKey]]));
    }
  }

  if (paramsToAppend.length > 0) {
    var queryString = paramsToAppend.join('&');

    var sfmcLinks = $('[href*="cloud.comms.oup.com.au"]');
    sfmcLinks.each(function (index, curr) {
      var currentLink = $(curr).attr('href');

      if (currentLink.indexOf('?') >= 0) {
        $(curr).attr('href', $(curr).attr('href') + '&' + queryString);
      } else {
        $(curr).attr('href', $(curr).attr('href') + '?' + queryString);
      }
    });
  }
}

leadTracking(jQuery);
